"use strict";
import ObjectWithIDStore from "./object_with_id_store";
var store = new ObjectWithIDStore("TMSShipment");
export default store;
